export var Configs = {
    serviceUrl: "",
    //serviceUrl: "http://itlead.vicp.net:9281/caishenghuo", 
    // serviceUrl: "http://192.168.2.153:8080",//测试URL 69  //192.168.2.205
    // serviceUrl: "https://market-test.colourlife.com",
    fileUpdateUrl: "https://market-test.colourlife.com",
    //  serviceUrl:"http://192.168.2.133:8080",//
    // serviceUrl:"http://192.168.2.147:8080",
    // fileserviceUrl: "http://itlead.vicp.net:3001",
    defaultUrl: "/home/index",
    defaultUrlCordova: "/user/index",
    loginUrl: "/account/login",
    // defaultUrl:"/acrcount/login",
    registerUrl: "/account/register",
    pageSize: 10
};
export var Topics = {
    app_location_changed: "app_location_changed",
    app_account_login: 'app_account_login'
};
